// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1uCTA","legacyBtn":"MutateMid_legacyBtn__oFDwH"};